(function () {
    const multiSearch = {
        init: function () {
            multiSearch.control();
        },
        control: function () {
            UX.resizeImages('.multi-search');
            multiSearch.hideMoreLinks();
            multiSearch.imageResize();
            UX.fancybox && multiSearch.fancybox();
        },
        imageResize: function () {
            const multiSearch = document.querySelector('.multi-search');
            if (multiSearch) {
                const abstractPreviewImg = UX.utils.convertToArray(
                        multiSearch?.querySelectorAll('.abstract-preview img')
                    ),
                    imageResize = e => UX.resizeImages(e.target.parentElement);

                if (abstractPreviewImg.length) {
                    abstractPreviewImg.forEach(item => {
                        UX.resizeImages(item.parentElement);
                        item.addEventListener('load', imageResize);
                    });
                }
            }
        },
        fancybox: function () {
            const abstractPreviewZoom = UX.utils.convertToArray(document.querySelectorAll('.abstract-preview__zoom'));
            UX.fancybox(abstractPreviewZoom);
            document.addEventListener('keydown', UX.fancyboxClose);
        },
        hideMoreLinks: function () {
            const $multiSearch = $('.multi-search'),
                $multiSearchList = $multiSearch.find('.multi-search__list'),
                $multiSearchEmpty = $multiSearch.find('.multi-search--empty'),
                $multiSearchNoResult = $multiSearch.find('.multi-search__no-result'),
                $moreLinks = $('.multi-search__more-links');

            if (($multiSearchList.hasClass('hideMoreLinks') || $multiSearchNoResult.length) && $moreLinks.length) {
                $moreLinks.remove();
            }

            if ($multiSearchEmpty.length) {
                $multiSearchEmpty.closest('.multi-search').prev('.multi-search__header').remove();
                $moreLinks.remove();
            }
        },
    };

    UX.multiSearch = multiSearch;
})();
